<template>
  <div
    class="ce-otherResultsHint"
    v-if="shouldShow">
    <i18n-t
      keypath="formulationRepository.searchPage.productResultsHint.content"
      tag="span"
      scope="global">
      {{ $t('formulationRepository.searchPage.productResultsHint.prefix', amountOfResults) }}
      <a :href="link">
        {{ $t('formulationRepository.searchPage.productResultsHint.link', amountOfResults) }}
      </a>
      {{ $t('formulationRepository.searchPage.productResultsHint.pigment', amountOfResults) }}
    </i18n-t>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import qs from 'qs';
import SearchConfig from '@sun-chemical/system-config/search-config';
import { cloneObject } from 'utils';

export default {
  computed: {
    ...mapState(['results']),
    ...mapState('generic', ['links']),
    ...mapGetters(['urlFilters']),
    hasIngredientFilter() {
      return !!this.urlFilters?.ingredient;
    },
    productResults() {
      return this.results?.products;
    },
    hasProductResults() {
      return this.productResults?.total > 0;
    },
    shouldShow() {
      if (this.hasIngredientFilter) {
        return true;
      }

      return this.hasProductResults;
    },
    amountOfResults() {
      if (this.hasIngredientFilter) {
        return 1;
      }

      if (this.hasProductResults) {
        return this.productResults.total;
      }

      return 0;
    },
    activeIndustryFilter() {
      if (this.urlFilters && this.urlFilters.i) {
        return typeof this.urlFilters.i === 'string' ? [this.urlFilters.i] : this.urlFilters;
      }

      return null;
    },
    isSingleIndustryActive() {
      return (this.activeIndustryFilter && this.activeIndustryFilter.length === 1);
    },
    link() {
      if (this.hasIngredientFilter) {
        let link = `${this.links.productsPage}${this.urlFilters.ingredient}`;

        if (this.isSingleIndustryActive) {
          link += `?i=${this.activeIndustryFilter[0]}`;
        }

        return link;
      }

      let link = `${this.links.productsPage}search`;

      if (this.productResults?.params && Object.keys(this.productResults.params).length > 0) {
        const params = cloneObject(this.productResults.params);
        const termParam = SearchConfig.getMap().search_term.param;

        if (params[termParam]) {
          params[termParam] = encodeURIComponent(params[termParam]);
        }

        link += `?${qs.stringify(params, { arrayFormat: 'comma', encode: false })}`;
      }

      return link;
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-otherResultsHint {
  position: relative;
  .ms(-2);
  margin: 0 0 @space-2;
  text-align: right;
}
</style>
